<template>
    <button>
        <slot></slot>
    </button>
</template>

<style scoped>
button {
    padding: 8px;
    border: 1px solid #000;
    transition: 0.3s ease;
}

button:hover,
button:active {
    border: 1px solid #8D8D8D;;
    background: #8D8D8D;
}
</style>